import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/resource/sidebar-logo.png'
import logonew from '../../assets/images/logo.png'
import imgone from '../../assets/images/resource/menu-image-1.jpg'
import imgtwo from '../../assets/images/resource/menu-image-2.jpg'
import Imgthree from '../../assets/images/resource/menu-image-3.jpg'
import Imgfour from '../../assets/images/resource/menu-image-4.jpg'


function Main() {

    const [active, setActive] = useState();
    const [show, setShow] = useState();
    const [menu, setMenu] = useState();
    const [page, setPage] = useState();
    const [drop, setDrop] = useState();
    const [lastscrool, setlastscrool] = useState(0);

    const [scrolled, setScrolled] = useState(false);
    const [Nav, setNav] = useState(true);

    const handleScroll = () => {

        const offset = window.scrollY;
        setlastscrool(offset);

        if (offset > 1000 && offset < lastscrool) {
            setNav(true);
            setScrolled(true);
        }

        else if (offset > 1000) {
            setNav(false)
        }

        else if (offset > 200) {
            setNav(true);
            setScrolled(true);
        }

        else {
            setScrolled(false);
            setNav(true);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
    })


    return (

        <>

            {active &&
                <div className="menu-backdrop" style={{ opacity: "1", visibility: "visible" }} onClick={() => setActive(false)}></div>}

            <section className={`hidden-bar ${active && "visible-sidebar"}`} onClick={() => setActive(false)} >
                <div className="inner-box">
                    <div className="cross-icon hidden-bar-closer" onClick={() => setActive(false)} ><span className="far fa-close"> </span></div>
                    <div className="logo-box"><Link to="/" title="Родос - Гръцки Ресторант"><img src={logo} alt="" title="Родос - Гръцки Ресторант" />
                    </Link></div>

                    <div className="side-menu">
                        <ul className="navigation clearfix">
                            {/* <li className="current dropdown"><Link to="/" onClick={() => setShow(show === true ? false : true)}>Home<button type="button" className="btn-expander" ><i className="far fa-angle-down"></i></button></Link>
                                    <ul style={{ display: show ? "block" : "none" }} >
                                        <li><Link to="/hometwo">Home 1 Left Header</Link></li>
                                        <li><Link to="/">Home 1 Center Header</Link></li>
                                        <li><Link to="/homethree">Home 3 Video Hero</Link></li>
                                    </ul>
                                </li> */}

                            <li><Link to="/">Начало</Link></li>
                            <li><Link to="/menu">Меню</Link></li>

                            <li><Link to="/reservation">Резервирай</Link></li>
                        </ul>
                    </div>

                    <h2>Адрес</h2>
                    <ul className="info">
                        <li>ул.Емборе 8 кв.Орландовци<br /> София </li>
                        <li>Отворено: 10:30 - 22:30</li>
                        {/* <li><Link to="mailto:booking@domainame.com">booking@domainame.com</Link></li> */}
                    </ul>
                    <div className="separator"><span></span></div>
                    <div className="booking-info">
                        <div className="bk-title">Резервация</div>
                        <div className="bk-no"><Link to="tel:+359 88 555 6520">088 555 6520</Link></div>
                    </div>

                </div>
            </section>
            {Nav &&
                <header className={`main-header ${scrolled && "fixed-header"} header-down`}>
                    <div className="header-top">
                        <div className="auto-container">
                            <div className="inner clearfix">
                                <div className="top-left clearfix">
                                    <ul className="top-info clearfix">
                                        <li><i className="icon far fa-map-marker-alt"></i> ул.Емборе 8 кв.Орландовци, София</li>
                                        <li><i className="icon far fa-clock"></i> Всеки ден : 10:30 - 22:30</li>
                                    </ul>
                                </div>
                                <div className="top-right clearfix">
                                    <ul className="top-info clearfix">
                                        <li><Link to="tel:088 555 6520"><i className="icon far fa-phone"></i> 088 555 6520 </Link> </li>
                                        <li><Link to="mailto:booking@restaurant.com"><i className="icon far fa-envelope">
                                        </i> atanasmartin1988@gmail.com
                                        </Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="header-upper header-fixed" >
                        <div className="auto-container">
                            <div className="main-box d-flex justify-content-between align-items-center flex-wrap">

                                <div className="links-box clearfix">
                                    <div className="nav-toggler">
                                        <button className="hidden-bar-opener">
                                            <span className="hamburger" onClick={() => setActive(true)}>
                                                <span className="top-bun"></span>
                                                <span className="meat"></span>
                                                <span className="bottom-bun"></span>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div className="logo-box">
                                    <div className="logo"><Link to="/" title="Родос - Гръцки Ресторант"><img src={logonew} alt="" title="Родос - Гръцки Ресторант" /></Link></div>
                                </div>

                               

                                <div className="link link-btn">
                                    <Link to="/reservation" className="theme-btn btn-style-two clearfix">
                                        <span className="btn-wrap">
                                            <span className="text-one">резервирай</span>
                                            <span className="text-two">резервирай</span>
                                        </span>
                                    </Link>
                                </div>

                            </div>
                        </div>
                    </div>
                </header>}

        </>

    )
}

export default Main